<template>
    <div class="staerke">
        <p>
            Iodkaliumiodid-Lösung ergibt violette Färbung durch
            Iod-Stärke-Komplex-Bildung
        </p>
    </div>
</template>

<script>
export default {
    name: 'staerke',
};
</script>
